export enum enumPromotionType {
    ptCustomerId = 1,
    ptPromoCode = 2,
}

export class PromotionType {
    public promotionTypeId: number;
    public description: string;
    public shortDescription: string;
    public order: number;

    static promotionTypes(): PromotionType[] {
        //return an array of all of PromotionTypes, populated for each item in the enum
        let promoTypes: PromotionType[] = new Array<PromotionType>();

        //loop through the keys in the enum
        //nb. typescript enums map to arrays in a strange way, with more entries than you'd think
        for (var i = 0; i < Object.keys(enumPromotionType).length; i++)
        {
            if (isNaN(Number(Object.keys(enumPromotionType)[i])))
            {
                let promoType: PromotionType = new PromotionType;
                promoType.promotionTypeId = <enumPromotionType>enumPromotionType[Object.keys(enumPromotionType)[i]];
                promoType.description = promoType.typeDescription();
                promoType.shortDescription = promoType.shortTypeDescription();
                promoType.order = promoType.typeOrder();
                promoTypes.push(promoType);
            }
        }

        return promoTypes.sort((promoType1, promoType2) => promoType1.order - promoType2.order);
    }

    public typeDescription(): string {
        let description: string = "<unknown>";

        switch (this.promotionTypeId) {
            case enumPromotionType.ptCustomerId:
                description = "Customer ID";
                break;

            case enumPromotionType.ptPromoCode:
                description = "Promo code";
                break;
        }

        return description;
    }

    public shortTypeDescription(): string {
        let description: string = "<unknown>";

        switch (this.promotionTypeId) {
            case enumPromotionType.ptCustomerId:
                description = "ID";
                break;

            case enumPromotionType.ptPromoCode:
                description = "Promo";
                break;
        }

        return description;
    }

    public typeOrder(): number {
        let order: number = 100;

        switch (this.promotionTypeId) {
            case enumPromotionType.ptCustomerId:
                order = 1;
                break;

            case enumPromotionType.ptPromoCode:
                order = 2;
                break;
        }

        return order;
    }
}